// The 14 core categories grouped into six departments (menu, What We Source hub, category pages).
export const DEPARTMENTS = [
  { id: "textiles-apparel", name: "Textiles & Apparel", items: [
    ["Garments & Apparel", "/garment-manufacturers-india"],
    ["Home Furnishings", "/home-furnishing-manufacturers-india"],
    ["Embroidered & Crocheted Goods", "/embroidered-crochet-products-manufacturers-india"],
    ["Hand-Printed Textiles", "/hand-block-printed-textile-manufacturers-india"],
  ] },
  { id: "kitchen-dining", name: "Kitchen & Dining", items: [
    ["Stainless Steel Utensils", "/stainless-steel-utensil-manufacturers-india"],
    ["Stainless Steel Flatware", "/cutlery-manufacturers-india"],
    ["Kitchen Tools & Accessories", "/kitchen-tools-accessories-manufacturers-india"],
    ["Glassware", "/glassware-manufacturers-india"],
  ] },
  { id: "fragrance-wellness", name: "Fragrance & Wellness", items: [
    ["Aroma & Essential Oils", "/essential-oil-aroma-oil-manufacturers-india"],
    ["Agarbattis, Incense & Attars", "/agarbatti-incense-attar-manufacturers-india"],
  ] },
  { id: "wooden-natural", name: "Wooden & Natural Products", items: [
    ["Woodware & Wooden Products", "/wooden-products-woodware-manufacturers-india"],
    ["Wicker, Rattan & Bamboo", "/wicker-rattan-bamboo-products-manufacturers-india"],
  ] },
  { id: "decorative", name: "Decorative Products", items: [
    ["Stone & Pottery Artware", "/stone-pottery-artware-manufacturers-india"],
    ["Home Decor", "/home-decor-manufacturers-india"],
  ] },
  { id: "fashion-accessories", name: "Fashion Accessories", items: [
    ["Imitation & Fashion Jewellery", "/imitation-fashion-jewellery-manufacturers-india"],
    ["Leather Products", "/leather-products-manufacturers-india"],
  ] },
];


// Old /what-we-source/<slug> pages replaced by full category pages (redirect + drop from sitemap).
export const MOVED_CATEGORIES = {
  "essential-oils": "/essential-oil-aroma-oil-manufacturers-india",
  "glassware": "/glassware-manufacturers-india",
  "ceramics-pottery": "/stone-pottery-artware-manufacturers-india",
  "wooden-home-accessories": "/wooden-products-woodware-manufacturers-india",
};
